/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';
import CommentsThreadDescriptor, { IThread, IThreadJSON } from '../descriptors/commentsthreaddescriptor';

export interface IUpdateCommentMessage extends IMessage {
	commentThreadId: string;
	content: string | undefined;
	documentId: string;
	commentId: string;
	attributes: string | null;
	isAttributesUpdated: boolean;
	commentThread?: IThreadJSON;
}

export default class UpdateCommentMessage extends Message {
	public static readonly TYPE: string = '96';

	public static readonly READABLE_TYPE_NAME: string = 'updateComment';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2UpdateCommentMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			commentId: {
				type: 'string',
				id: 2
			},
			content: {
				type: 'string',
				id: 3
			},
			documentId: {
				type: 'string',
				id: 4
			},
			attributes: {
				type: 'string',
				id: 5
			},
			isAttributesUpdated: {
				type: 'bool',
				id: 6
			},
			commentThread: {
				type: 'CommentsThreadDescriptor',
				id: 7
			}
		}
	};

	public constructor(
		public readonly documentId: string,
		public readonly commentThreadId: string,
		public readonly commentId: string,
		public readonly content?: string,
		public readonly attributes: Record<string, unknown> | null = null,
		public readonly isAttributesUpdated: boolean = false,
		public readonly commentThread?: IThread
	) {
		super();
	}

	public toJSON(): IUpdateCommentMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId,
			commentId: this.commentId,
			content: this.content,
			attributes: this.attributes ? JSON.stringify( this.attributes ) : null,
			isAttributesUpdated: this.isAttributesUpdated,
			commentThread: this.commentThread ? CommentsThreadDescriptor.toJSON( this.commentThread ) : undefined
		};
	}

	public static fromJSON( object: IUpdateCommentMessage ): UpdateCommentMessage {
		return new UpdateCommentMessage(
			object.documentId,
			object.commentThreadId,
			object.commentId,
			object.content,
			object.attributes ? JSON.parse( object.attributes ) : null,
			object.isAttributesUpdated,
			object.commentThread ? CommentsThreadDescriptor.fromJSON( object.commentThread ) : undefined
		);
	}
}
